export interface GridPreference {
  column: string;
  visible: boolean;
  order: number;
}

export interface UserPreferences {
  grid: {
    columns: GridPreference[];
    viewMode?: 'grid' | 'cards' | 'calendar';
  };
}

export const DEFAULT_GRID_PREFERENCES: GridPreference[] = [
  { column: 'name', visible: true, order: 0 },
  { column: 'client', visible: true, order: 1 },
  { column: 'startDate', visible: true, order: 2 },
  { column: 'comments', visible: true, order: 3 },
  { column: 'status', visible: true, order: 4 },
  { column: 'assignee', visible: true, order: 5 },
  { column: 'endDate', visible: true, order: 6 },
  { column: 'expirationDate', visible: true, order: 7 },
  { column: 'priority', visible: true, order: 8 },
  { column: 'notes', visible: true, order: 9 },
  { column: 'updatedAt', visible: true, order: 10 },
  { column: 'vehicle', visible: true, order: 11 },
  { column: 'partNumber', visible: false, order: 12 }
];